export default "assets/logo-14f07daa.png";